import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { Zone } from "../_types/zone";
import * as saveAs from "file-saver";
import * as slug from "slug";
import { AsyncSubject, Observable } from "rxjs";

@Injectable({
  providedIn: 'root',
})
export class ZonesService extends Service<Zone> {
  public override type = 'zones';
  public override url = 'providers/zones';

  public downloadExcel(zoneId: string, filename: string | null) {
    let url = this.getAPIUrl() + "/" + zoneId + '/downloadExcel';
    return this.http.get(url, { responseType: 'blob' }).subscribe((response: Blob) => {
      // Usar FileSaver.js para guardar el archivo
      saveAs(response, (filename != null ? slug(filename) + '.xlsx' : 'zonas.xlsx'));
    });
  }


  public uploadExcel(id: string, file: any): Observable<any> {

    let subject = new AsyncSubject<any>();

    let data = new FormData();
    data.append('file', file);

    let url = this.getAPIUrl() + '/' + id + '/uploadExcel';

    this.http.put(url, data).subscribe({
      next: (response) => {
        //console.log('Resource updated successfully', response);
        subject.next(response);
        subject.complete();
        // Limpiar el mensaje de error si la solicitud fue exitosa
      },
      error: (error) => {
        subject.error(error);
      }
    });
    return subject.asObservable();
  }
}
